import axiosMobileInstance from "./axiosMobileInstance/axiosMobileInstance";
import {
  MatchRateBreakdown,
  MatchRateBreakdownRequest,
  MatchRateFilters,
  MatchRateSummary,
} from "../types/matchRate.types";

export const getMatchRateSummary = async (filters: MatchRateFilters = {}) => {
  const { data } = await axiosMobileInstance.post<MatchRateSummary>(
    "/match_rate/summary",
    filters
  );
  return data;
};

export const getMatchRateBreakdown = async (
  request: MatchRateBreakdownRequest
) => {
  const { data } = await axiosMobileInstance.post<MatchRateBreakdown>(
    "/match_rate/breakdown",
    request
  );
  return data;
};
